import { getAuthCode } from "./getAuthCode";
export const fetchFeed = async (setFeedItems,setInputLength) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/retrievefeed", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      console.log(result.placeholder);
      const feeds = result.feed;
      const alreadySeenScans = localStorage.getItem("scansSeen");
      const alreadySeenScansParsed = JSON.parse(alreadySeenScans);
      let parsedData = [];
      let seenScans = []
      for(let i=0;i<feeds.length;i++){
        let nugget = feeds[i].content;
        let domain = feeds[i].domain;
        let scanDate = new Date(feeds[i].content.date).toDateString();
        if(nugget.pagesAdded.length>0){
          for(let x=0;x<nugget.pagesAdded.length;x++){
            seenScans.push(feeds[i].content.date);
            let obj = {date:scanDate,tag:'New content',site:domain,url:nugget.pagesAdded[x].url,title:nugget.pagesAdded[x].title,excerpt:nugget.pagesAdded[x].description,image:nugget.pagesAdded[x].image,placeholder:result.placeholder};
            let hasBeenSeen = false;
            if(alreadySeenScansParsed!==null){
              if(alreadySeenScansParsed.includes(feeds[i].content.date)){hasBeenSeen=true};
            }
            obj.hasBeenSeen = hasBeenSeen;
            parsedData.push(obj);
          }
        }
        /*if(nugget.pagesRemoved.length>0){
          for(let x=0;x<nugget.pagesRemoved.length;x++){
            parsedData.push({date:scanDate,tag:'Removed content',site:domain,url:nugget.pagesRemoved[x],title:'Deleted content',excerpt:'Download this light, bulb, lamp, creative, idea icon. Available in PNG and SVG formats. No signup required.'})
          }
        }*/
      }
      parsedData.sort((a, b) => new Date(b.date) - new Date(a.date));
      localStorage.setItem("scansSeen",JSON.stringify(seenScans));
      setFeedItems(parsedData);
      setInputLength(result.numberOfInputs);
    } catch (error) {
      console.log(error);
    }
  };